import styled from "styled-components";

export const Container = styled.form`
    padding: 20px;
    background-color: ${({ theme }) => theme.white};
    display: flex;
    flex-direction: column;
    gap: 30px;
    width: 500px;
    border-radius: 8px;
`;

export const Title = styled.h2`
    color: ${({ theme }) => theme.purple600};
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 600;
`;

export const Fields = styled.section`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const SwitchWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    color: ${({ theme }) => theme.gray800};
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
`;

export const Buttons = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
`;
